export default function Error401() {
  return (
    <>
      <p>L'accès à cette ressource est interdit</p>
      <p>Veuillez réessayer d'accéder au portail à partir du syspap</p>
    </>
  )
}
